<template>
  <div class="add">
    <div class="top">
      <Input
        placeholder="搜索"
        @on-clear="selectNewBasExamSuiteList(1)"
        @on-enter="selectNewBasExamSuiteList(1)"
        class="journal-input"
        clearable
        v-model="name"
      >
        <Icon type="ios-search" slot="prefix" />
      </Input>
    </div>
    <Table
      @on-sort-change="changesort"
      @on-selection-change="selectChange"
      stripe
      :columns="columns"
      :data="data"
    ></Table>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page
        :total="obj.total"
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>
    <div style="clear:both;"></div>
    <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="clear(1)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="clear(2)"
          >确定</Button
        >
      </div> 
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        formatMoney,
        selectNewBasExamSuiteList,
        getSuiteSort
    } from "../servers/api";
    export default {
        props: {
            classifyId: {
            type: Number,
            default: -1
            }
        },
        data() {
            return {
                dataClassify:[],
                isiconfontshow: false,
                selectNum: 0,
                selectList: [],
                sendList: [],
                pageSize: 20,
                current: 1,
                name: "",
                columns: [{
                    type: "selection",
                    width: 60,
                    align: "center"
                }, {
                    title: "套餐名称",
                    key: "examSuiteName",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "套餐金额",
                    key: "price",
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        let a = "￥" + formatMoney(params.row.price);
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "性别",
                    width: 120,
                    key: "useSex",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "婚姻状态",
                    width: 120,
                    key: "marry",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                },{
                    title: '套餐分类',
                    key: 'taocanClassifyList',
                    render:(h,params)=>{
                        //  console.log(params.row.taocanClassifyList,'params.row.taocanClassifyListmap')
                        return h('Select',{
                            props:{
                                    value:this.classifyId
                            },
                            on:{
                                'on-change':(e)=>{
                                    console.log(e,'66')
                                    this.data[params.index].classifyId = e;
                                    }
                                    }
                                },
                                params.row.taocanClassifyList ? params.row.taocanClassifyList.map((item)=>{
                                    return h('Option',{
                                        props:{
                                            value:item.id,
                                            label:item.classifyName
                                    }           
                                })
                            }) : ''
                            )
                        }
                    }],
                data: [{}],
                orderField: "",
                isAsc: "",
                vmodel:'111',
                obj: {}
            };
        },
        methods: {
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectChange([]);
                this.selectNewBasExamSuiteList();
            },
            changepeoplepage(item) {
                //切换条数
                this.selectChange([]);
                this.selectNewBasExamSuiteList();
            },
            changesort(itme) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectNewBasExamSuiteList(1);
            },
            selectChange(list) {
                //多选
                this.selectList = list;
                this.selectNum = this.selectList.length;
            },
            clear(index) {
                if(index == 1){
                    this.$emit("postSelectd", []);
                }else{    
                    this.sendList = this.data.filter(item => {return this.selectList.find(itemSelect => item.idExamSuite === itemSelect.idExamSuite)})
                    this.$emit("postSelectd", this.sendList);
                }
            },
            selectNewBasExamSuiteList(index) {
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    name: this.name,
                    orderField: this.orderField,
                    isAsc: this.isAsc,
                    pageNum: this.current,
                    pageSize: this.pageSize
                };
                selectNewBasExamSuiteList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data;
                       // this.data = res.data.data.list;
                        res.data.data.list.forEach((item) => {
                            item.taocanClassifyList = this.dataClassify
                            item.classifyId = this.classifyId
                        })
                       this.data = res.data.data.list;
                       console.log(this.data,'this.datathis.data')
                    }
                });
            },
            getSuiteSort(){
              getSuiteSort().then(res => {
                if (res.data.code == 1) {
                        this.dataClassify = res.data.data;
                    }
              })
            }
        },
        created() {
            this.getSuiteSort();
        },
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .add {
        width: 100%;
        max-height: 500px;
        overflow: hidden;
        overflow-y: visible;
    }
    
    .top {
        width: 100%;
        height: 45px;
    }
    
    .journal-input {
        width: 250px;
    }
    
    .page-div {
        width: 100%;
        margin-top: 15px;
        .page-div-left {
            float: left;
            padding: 5px 10px;
        }
        .page-div-lefts {
            border-right: 1px solid #d7d7d7;
            margin-right: 15px;
        }
        .page-div-page {
            float: right;
            margin-right: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/tan/add.vue